<div class="btn-toggle" >
    <ng-container *ngFor="let item of items">
        <a *ngIf="item?.href" class="btn" [attr.data-tooltip]="item.label" [href]="item.href" target="_blank">
            <div class="btn-icon">
                <mat-icon [svgIcon]="item.icon" matBadge="2" matBadgePosition="before" matBadgeColor="warn" style="{{item.style}}"></mat-icon>
            </div>
        </a>

        <a *ngIf="item?.link" class="btn" [attr.data-tooltip]="item.label" (click)="navigateToSimulatedPath(item.link);" [class.active]="routeActive === item.link">
            <div class="btn-icon" >
                <mat-icon [@iconState]="item.icon === 'notace' ? iconState : 'inactive'" [svgIcon]="item.icon" style="{{item.style}}"></mat-icon>
                <span *ngIf="item.icon === 'notace' && iconState === 'active'" ></span>
            </div>
        </a>

        <a *ngIf="item?.event" class="btn" [attr.data-tooltip]="item.label" (click)="mapComponent.displayStops()">
            <div class="btn-icon">
                <mat-icon [svgIcon]="item.icon" [@iconState]="item.icon === 'notace' ? iconState : 'inactive'" style="{{item.style}}"></mat-icon>
            </div>
        </a>
    </ng-container>
</div>
